import axios from '@/libs/api.request'
// 获取学生列表
export const getMenteesList = data => {
  return axios.request({
    url: '/joint/mentees',
    data,
    method: 'POST'
  })
}
